import { objectSelector } from 'theme/utils';

const $P = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/packageDeliveryRanges`);

class PackageDeliveryRanges {
  constructor(data) {
    const { results } = data;
    this.results = results;
  }
}

class DeliveryRange {
  constructor(deliveryRange) {
    const { id, lower, upper } = deliveryRange;
    this.id = id;
    this.lower = lower;
    this.upper = upper;
  }
}

const deliveryMapper = (deliveryRanges) => {
  return deliveryRanges.map((item, index) => {
    return new DeliveryRange({
      id: `${index + 1}`,
      lower: objectSelector(item, $P.DELIVERY_RANGE.LOWER),
      upper: objectSelector(item, $P.DELIVERY_RANGE.UPPER),
    });
  });
};

export const packageDeliveryRangesMapper = (data) => {
  return new PackageDeliveryRanges({
    results: deliveryMapper(objectSelector(data, $P.DELIVERY_RANGES, [])),
  });
};



// WEBPACK FOOTER //
// ./src/models/packageDeliveryRanges.js